import { GtmHelper } from '@bcp-channels-sharedcomponents-reactjs/core/dist/helpers';

import { flowManager } from '../flowManager';

export const clPublicSimulator = flowManager.flow({ name: 'clPublicSimulator', baseUrl: 'cl-public-simulator' }).steps({
	simulator: { initialStep: true },
});

clPublicSimulator.step('simulator')({});

clPublicSimulator.listen({
	callback: ({ currentStepName }) => {
		// GtmHelper.sendScreenView({
		// 	screen_name: currentStepName,
		// });
	},
	type: 'mount',
});

clPublicSimulator.listen({
	callback: ({ currentStepName, dispatch }) => {
		const { actionName } = dispatch || {};

		// if (dispatch && actionName) {
		// 	GtmHelper.sendEvent({
		// 		screen_name: currentStepName,
		// 		eName: actionName,
		// 	});
		// }
	},
	type: 'dispatch',
});
